/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取电子票明细的二维码信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class OrderETicketQrcodeParams {
  constructor(public orderDetailId: string) {}
}

export default async function (
  params: OrderETicketQrcodeParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.QrcodeDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/eticket-qrcode`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
